import React from 'react'

function BufferMenu() {
  return (
    <div>BufferMenu</div>
  )
}

export default BufferMenu